import { render, staticRenderFns } from "./SliderLayout.vue?vue&type=template&id=3ebac615&scoped=true&"
import script from "./SliderLayout.vue?vue&type=script&lang=ts&"
export * from "./SliderLayout.vue?vue&type=script&lang=ts&"
import style0 from "./SliderLayout.vue?vue&type=style&index=0&id=3ebac615&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebac615",
  null
  
)

export default component.exports